import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";
import SectionHeading from "@/components/feature/SectionHeading";
import { formatViews } from "@/utils/format";

const hot = [...movies].sort((a, b) => b.views - a.views).slice(0, 6);
const maxViews = hot[0]?.views ?? 1;

export default function HotRanking() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="Trending Now"
          title="热门影视推荐"
          description="依据站内演示播放量排序，帮助你快速找到近期讨论度较高的作品。"
          action={
            <span className="inline-flex items-center gap-1.5 rounded-md bg-background-50 px-3 py-1.5 text-xs text-foreground-500">
              <i className="ri-fire-line w-4 h-4 flex items-center justify-center text-accent-500" />
              每小时更新（演示数据）
            </span>
          }
        />

        <div className="grid grid-cols-1 gap-x-10 gap-y-1 md:grid-cols-2">
          {hot.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/detail/${movie.id}`}
              className="group flex items-center gap-4 rounded-lg px-2 py-4 transition-colors hover:bg-background-50 md:px-3"
            >
              <span className="w-8 shrink-0 text-center font-label text-xl font-bold text-background-400 transition-colors group-hover:text-accent-500">
                {String(index + 1).padStart(2, "0")}
              </span>
              <div className="h-[84px] w-14 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={movie.poster}
                  alt={`${movie.title}封面`}
                  title={`${movie.title} 影视详情`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="truncate text-sm font-medium text-foreground-950 transition-colors group-hover:text-accent-600">
                    {movie.title}
                  </h3>
                  <span className="shrink-0 rounded-sm bg-secondary-100 px-1.5 py-0.5 text-[10px] text-secondary-800">
                    {movie.type}
                  </span>
                </div>
                <p className="mt-1 truncate text-xs text-foreground-500">{movie.summary}</p>
                <div className="mt-2 flex items-center gap-3">
                  <span className="flex items-center gap-1 font-label text-[11px] text-accent-600">
                    <i className="ri-star-fill text-[10px] leading-none" />
                    {movie.rating.toFixed(1)}
                  </span>
                  <div className="h-1 w-20 overflow-hidden rounded-full bg-background-300 md:w-28">
                    <div
                      className="h-full rounded-full bg-accent-500"
                      style={{ width: `${Math.round((movie.views / maxViews) * 100)}%` }}
                    />
                  </div>
                  <span className="text-[11px] text-foreground-500">播放 {formatViews(movie.views)}</span>
                </div>
              </div>
              <i className="ri-arrow-right-s-line hidden w-5 h-5 items-center justify-center text-foreground-400 transition-all group-hover:translate-x-1 group-hover:text-accent-500 sm:flex" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}